export default __webpack_public_path__ + "static/media/object.e7ab4c7f.svg";